import {} from './money.js';
/**
 * Travel economics (spec §3.7, sheet "Travel").
 *
 * A trip is a planned journey with a set of cost lines (fly / hotel / transport /
 * dagligt / aktiviteter …). Its total is simply the sum of those lines. When a trip is
 * "posted to net worth" it becomes a *consumptive* one-off in the ledger in its month —
 * a travel spends accumulated fortune, it does not convert into an asset.
 */
/** Trip total = Σ cost lines (every amount sunk into the trip). */
export function tripTotal(costLines) {
    return costLines.reduce((sum, c) => sum + c, 0);
}
//# sourceMappingURL=travel.js.map